import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../layout/Layout";
import "animate.css";
import sumly_shopping from "../../assets/sumly_shopping.png";
import sumly_linkedin from "../../assets/sumly_linkedin.png";
import sumly_webpage from "../../assets/sumly_webpage.png";
import sumly_targetwebpage from "../../assets/sumly_targetwebpage.png";
import sumly_socialmedia from "../../assets/sumly_socialmedia.png";
import sumly_aichat from "../../assets/sumly_aichat.png";
import sumly_github from "../../assets/sumly_github.png";
import sumly_emails from "../../assets/sumly_emails.png";
import sumly_forms from "../../assets/sumly_forms.png";
import sumly_document from "../../assets/sumly_document.png";
import sumly_main1 from "../../assets/sumly_main1.png";
import sumly_main2 from "../../assets/sumly_main2.png";

function Sumly() {
  const { feature: featureParam } = useParams();
  const navigate = useNavigate();
  const [loadingStates, setLoadingStates] = useState({
    askable: true,
    "sticky-notes": true,
    "currency-convert": true,
    "video-esign": true,
    summarize: true,
    "video-ats": true,
  });

  const features = [
    "Askable",
    "Sticky Notes",
    "Currency Convertor",
    "E-Sign PDF",
    "ATS Resume Fix",
    "Summarize",
    "Web Pages",
    "Selected Text",
    "Shopping Product",
    "Social Media",
    "LinkedIn",
    "GitHub",
    "AI Chats",
    "Emails",
    "Documents",
    "Forms",
  ];

  const handleFeatureClick = (feature) => {
    // Map features to their corresponding image IDs
    const imageMap = {
      Askable: { id: "video-askable", slug: "askable" },
      "Sticky Notes": { id: "sticky-notes", slug: "sticky-notes" },
      "Currency Convertor": {
        id: "currency-convert",
        slug: "currency-convertor",
      },
      "E-Sign PDF": { id: "video-esign", slug: "esignPdf" },
      "ATS Resume Fix": { id: "video-ats", slug: "resume-fix" },
      Summarize: { id: "summarize", slug: "summarize" },
      "Web Pages": { id: "image-web-pages", slug: "web-pages" },
      LinkedIn: { id: "linkedin", slug: "linkedin" },
      "Selected Text": { id: "image-target-web-pages", slug: "selected-text" },
      Documents: { id: "image-documents", slug: "documents" },
      "Shopping Product": { id: "image-shopping", slug: "shopping-product" },
      "Social Media": { id: "image-social", slug: "social-media" },
      "AI Chats": { id: "image-ai-chats", slug: "ai-chats" },
      GitHub: { id: "image-github", slug: "github" },
      Emails: { id: "image-emails", slug: "emails" },
      Forms: { id: "image-forms", slug: "forms" },
    };

    const featureData = imageMap[feature];
    if (!featureData) return;

    // First, scroll to the images container
    const imagesContainer = document.getElementById("sumly-images");
    if (imagesContainer) {
      imagesContainer.scrollIntoView({ behavior: "smooth" });
    }

    // Then, after a short delay, scroll to the specific image
    setTimeout(() => {
      const imageElement = document.getElementById(featureData.id);
      const scrollContainer = document.getElementById(
        "images-scroll-container"
      );

      if (imageElement && scrollContainer) {
        // Calculate the position relative to the scroll container
        const containerRect = scrollContainer.getBoundingClientRect();
        const elementRect = imageElement.getBoundingClientRect();
        const scrollPosition =
          elementRect.top - containerRect.top + scrollContainer.scrollTop;

        scrollContainer.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });

        // Update the URL in the browser's address bar
        navigate(`/sumly/${featureData.slug}`);
      }
    }, 500);
  };

  // Handle iframe load events
  const handleIframeLoad = (videoId) => {
    setLoadingStates((prev) => ({
      ...prev,
      [videoId]: false,
    }));
  };

  // Handle URL parameters on page load (e.g. /sumly/askable)
  useEffect(() => {
    if (!featureParam) return;

    const slugToFeature = {
      askable: "Askable",
      "sticky-notes": "Sticky Notes",
      "currency-convertor": "Currency Convertor",
      esignPdf: "E-Sign PDF",
      "resume-fix": "ATS Resume Fix",
      summarize: "Summarize",
      "web-pages": "Web Pages",
      linkedin: "LinkedIn",
      "selected-text": "Selected Text",
      documents: "Documents",
      "shopping-product": "Shopping Product",
      "social-media": "Social Media",
      "ai-chats": "AI Chats",
      github: "GitHub",
      emails: "Emails",
      forms: "Forms",
    };

    const featureName = slugToFeature[featureParam];
    if (!featureName) return;

    setTimeout(() => {
      const imageMap = {
        Askable: { id: "video-askable", slug: "askable" },
        "Sticky Notes": { id: "sticky-notes", slug: "sticky-notes" },
        "Currency Convertor": {
          id: "currency-convert",
          slug: "currency-convertor",
        },
        "E-Sign PDF": { id: "video-esign", slug: "esignPdf" },
        "ATS Resume Fix": { id: "video-ats", slug: "resume-fix" },
        Summarize: { id: "summarize", slug: "summarize" },
        "Web Pages": { id: "image-web-pages", slug: "web-pages" },
        LinkedIn: { id: "linkedin", slug: "linkedin" },
        "Selected Text": {
          id: "image-target-web-pages",
          slug: "selected-text",
        },
        Documents: { id: "image-documents", slug: "documents" },
        "Shopping Product": {
          id: "image-shopping",
          slug: "shopping-product",
        },
        "Social Media": { id: "image-social", slug: "social-media" },
        "AI Chats": { id: "image-ai-chats", slug: "ai-chats" },
        GitHub: { id: "image-github", slug: "github" },
        Emails: { id: "image-emails", slug: "emails" },
        Forms: { id: "image-forms", slug: "forms" },
      };

      const featureData = imageMap[featureName];
      if (!featureData) return;

      const imagesContainer = document.getElementById("sumly-images");
      if (imagesContainer) {
        imagesContainer.scrollIntoView({ behavior: "smooth" });
      }

      setTimeout(() => {
        const imageElement = document.getElementById(featureData.id);
        const scrollContainer = document.getElementById(
          "images-scroll-container"
        );

        if (imageElement && scrollContainer) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const elementRect = imageElement.getBoundingClientRect();
          const scrollPosition =
            elementRect.top - containerRect.top + scrollContainer.scrollTop;

          scrollContainer.scrollTo({
            top: scrollPosition,
            behavior: "smooth",
          });
        }
      }, 500);
    }, 100);
  }, [featureParam]);

  return (
    <Layout>
      <div className="pt-16 md:pt-20 bg-white">
        <div className="flex flex-col space-y-2 sm:space-y-10 mx-auto py-2 ">
          <div className="flex justify-center items-center pl-6 pr-6 pb-16 md:pl-12 md:pr-12 lg:pl-24 lg:pr-24 bg-white animate__animated animate__fadeIn">
            <div className="grid grid-cols-1 max-w-6xl items-stretch mx-auto gap-12">
              <div className="flex flex-col justify-center items-center gap-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 p-8 md:p-12 bg-white shadow-[0_0_10px_rgba(0,0,0,0.05)] rounded-2xl">
                  <div className="flex flex-col space-y-6">
                    <div className="bg-white rounded-xl  transform transition-transform duration-300 hover:scale-105">
                      <h4 className="text-xl font-semibold text-gray-800 mb-4">
                        Sumly - Maximize Your Workflow with 6-in-1 Power
                      </h4>
                      <div className="flex flex-col gap-2 bg-gray-50 p-6 rounded-xl">
                        <p className="text-gray-700 text-md">
                          <a
                            href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-0.5 px-1 border border-gray-700 rounded-md transition duration-300 ease-in-out">
                              Sumly
                            </button>
                          </a>{" "}
                          is your all-in-one Chrome extension that lets you
                          instantly{" "}
                          <Link to="/sumly/summarize">
                            <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-0.5 px-1 border border-gray-700 rounded-md transition duration-300 ease-in-out">
                              Summarize
                            </button>
                          </Link>{" "}
                          webpages, shopping products, job postings, AI chats,
                          files, and more in your preferred language and format.
                          Enhance your{" "}
                          <Link to="/sumly/resume-fix">
                            <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-0.5 px-1 border border-gray-700 rounded-md transition duration-300 ease-in-out">
                              Resume
                            </button>
                          </Link>{" "}
                          with ATS-powered fixes in your preferred language.
                          <Link to="/sumly/esignPdf">
                            <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-0.5 px-1 border border-gray-700 rounded-md transition duration-300 ease-in-out">
                              E-sign
                            </button>
                          </Link>{" "}
                          multi-page PDFs completely offline without internet or
                          API keys. Add{" "}
                          <Link to="/sumly/sticky-notes">
                            <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-0.5 px-1 border border-gray-700 rounded-md transition duration-300 ease-in-out">
                              Sticky notes
                            </button>
                          </Link>{" "}
                          to any webpage that stay until removed. Convert
                          selected or full-page{" "}
                          <Link to="/sumly/currency-convertor">
                            <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-0.5 px-1 border border-gray-700 rounded-md transition duration-300 ease-in-out">
                              Currency Values
                            </button>
                          </Link>{" "}
                          into your target currency instantly with a single
                          click. Use{" "}
                          <Link to="/sumly/askable">
                            <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-0.5 px-1 border border-gray-700 rounded-md transition duration-300 ease-in-out">
                              Askable
                            </button>
                          </Link>{" "}
                          to get AI-powered answers by selecting text or marking
                          areas.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="hidden lg:flex flex-col justify-center gap-6">
                    <div className="w-full h-96 overflow-y-scroll hide-scrollbar rounded-xl border border-gray-200">
                      {/* Image gallery container */}
                      <a
                        href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={sumly_main1}
                          alt="Sumly"
                          className="w-full h-50 object-contain"
                        />
                      </a>
                      <hr className="border-t-2 border-gray-300 my-8" />
                      <a
                        href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={sumly_main2}
                          alt="Sumly"
                          className="w-full h-50 object-contain"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 sm:flex sm:gap-2 gap-2">
                  <a href="#installation" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      API Key Setup
                    </button>
                  </a>
                  <a href="#access_points" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      Installation
                    </button>
                  </a>
                  <a href="#problem_solving" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 xs:px-2 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      Problem Solving
                    </button>
                  </a>
                  <a href="#sumly-images" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      Features
                    </button>
                  </a>
                  <a href="#all-about-sumly" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      All about Sumly
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex justify-center items-center pt-16 pl-6 pr-6 pb-8 sm:p-16 md:p-24 md:pl-12 md:pr-12 md:pt-20 lg:pl-24 lg:pr-24 bg-gray-50"
            id="publications"
          >
            <div className="grid grid-cols-1 gap-16 md:gap-20 items-stretch max-w-6xl mx-auto">
              {/* Installation */}
              <div
                id="installation"
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
              >
                <div>
                  <div className="flex justify-center items-center gap-2">
                    <a
                      href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                        API Key Setup
                        <span className="inline-block align-top -translate-y-2 transform ml-2">
                          {"\u2197"}
                        </span>
                      </h2>
                    </a>
                    <div className="flex justify-center items-center gap-1 mb-7">
                      <div className="relative text-xs leading-[0.9rem] text-gray-500 rounded-[12px] px-1.5 border border-gray-500 group">
                        i
                        <div className="hidden group-hover:block absolute right-5 bottom-[-10px] bg-white text-black border border-gray-300 rounded-xl text-xs px-3 py-2 z-[1000] w-[263px] pointer-events-none">
                          You don't need an API key to use the eSignPDF, Sticky
                          Notes, or Currency Convertor features. The eSignPDF
                          feature works completely offline, no internet
                          connection is required.{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center">
                    <div className="max-w-6xl">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 1</div>
                          <div className="text-sm">
                            Install the extension and enter your Gemini API key
                            if you already have one. If not, click on the{" "}
                            <a
                              href="https://aistudio.google.com/app/apikey"
                              target="_blank"
                              rel="noreferrer"
                              className="hover:underline text-blue-700"
                            >
                              Google AI Studio
                            </a>{" "}
                            link to get one.
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 2</div>
                          <div className="text-sm">
                            After clicking the Google AI Studio link, you'll be
                            redirected to the API key page, where you need to
                            click on the 'Get API Key' option.
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 3</div>
                          <div className="text-sm">
                            Then, select the required options to agree to the
                            API policy and click 'I Accept'.
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 4</div>
                          <div className="text-sm">
                            Click on 'Create API Key' to generate your API key,
                            then click 'Copy' to copy it and paste it into the
                            extension settings window.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Problem Statement Flow */}
              <div
                id="problem_solving"
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
              >
                <div>
                  <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                    PROBLEM IDENTIFICATION
                  </h2>
                  <div className="flex justify-center">
                    <div className="max-w-6xl">
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 1</div>
                          <div className="text-sm">
                            Struggling to quickly summarize webpages, job
                            listings, documents, and more
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 2</div>
                          <div className="text-sm">
                            Tired of scrolling through endless product details
                            while shopping online
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 3</div>
                          <div className="text-sm">
                            Struggling to understand complex GitHub repositories
                            and documentation
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 4</div>
                          <div className="text-sm">
                            Recalling email details by reading entire threads
                            from top to bottom
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 5</div>
                          <div className="text-sm">
                            Revisiting ChatGPT conversation history to find
                            previous discussions
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 6</div>
                          <div className="text-sm">
                            Processing lengthy PDF documents and presentations
                            for key points
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 7</div>
                          <div className="text-sm">
                            Extracting insights from social media profiles and
                            posts manually
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 8</div>
                          <div className="text-sm">
                            Struggling to tailor your resume to match job
                            descriptions and pass ATS scans
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 9</div>
                          <div className="text-sm">
                            Wasting time and money searching for a way to e-sign
                            your PDFs
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 10</div>
                          <div className="text-sm">
                            Struggling to remember key points or keep track of
                            your thoughts while browsing
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 11</div>
                          <div className="text-sm">
                            Struggling to get AI-powered answers for any
                            question type directly on a webpage.
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 12</div>
                          <div className="text-sm">
                            Tired of guessing currency values while browsing
                            jobs, shopping, booking, and more
                          </div>
                        </div>
                      </div>

                      <div className="text-center mt-6 pt-2">
                        <a
                          href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="inline-block border-2 border-black p-4 bg-gray-100">
                            <strong className="text-xl">
                              UNIFIED SOLUTION: SUMLY
                            </strong>
                            <br />
                            <span className="text-sm">
                              Summarize • ResumeFix • esignPDF • Sticky Notes •
                              Askable • Currency Convertor
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*Examples*/}
              <div
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
                id="sumly-images"
              >
                <div>
                  <div className="flex flex-col justify-center items-center mb-6">
                    <h2 className="text-2xl font-semibold text-center pb-4">
                      FEATURES IN ACTION
                    </h2>

                    <p className="text-md md:text-lg text-slate-600 text-center leading-normal xs:leading-normal md:leading-normal">
                      {" "}
                      Click on each feature to understand its functionality,
                      supported by an image or a video showing its usage.
                    </p>
                  </div>
                  <div className="grid grid-cols-1 gap-10 max-w-5xl mx-auto">
                    <div className="flex justify-center flex-wrap gap-1.5 xs:gap-2">
                      {features.map((feature, index) => (
                        <div
                          key={index}
                          className="flex"
                          onClick={() => handleFeatureClick(feature)}
                        >
                          <button className="w-full bg-black hover:bg-white hover:text-black text-white font-semibold text-[12px] xs:text-[13px] py-2 px-3 md:py-3 md:px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out">
                            {feature}
                          </button>
                        </div>
                      ))}
                    </div>
                    <div
                      id="images-scroll-container"
                      className="w-full h-[14rem] xs:h-[18rem] sm:h-[20rem] md:h-[24rem] slg:h-[28rem] lg:h-[31rem] overflow-y-scroll hide-scrollbar rounded-xl border border-gray-200"
                    >
                      <div
                        style={{
                          position: "relative",
                          paddingTop: "56.25%" /* 16:9 ratio */,
                        }}
                        id="sticky-notes"
                      >
                        {loadingStates["sticky-notes"] && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                            <div className="text-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-2"></div>
                              <p className="text-sm text-gray-600">
                                Loading video...
                              </p>
                            </div>
                          </div>
                        )}

                        <iframe
                          src="https://www.loom.com/embed/b6deee96e2f040b390b6f1f5dfde3afa?sid=9455cf8e-7539-4a1a-9ef7-724d3163d2b2"
                          frameborder="0"
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowfullscreen
                          title="Sticky Notes video"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                          onLoad={() => handleIframeLoad("sticky-notes")}
                        ></iframe>
                      </div>
                      <hr className="border-t-2 border-gray-300 my-10" />

                      <div
                        style={{
                          position: "relative",
                          paddingTop: "56.25%" /* 16:9 ratio */,
                        }}
                        id="video-askable"
                      >
                        {loadingStates["askable"] && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                            <div className="text-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-2"></div>
                              <p className="text-sm text-gray-600">
                                Loading video...
                              </p>
                            </div>
                          </div>
                        )}
                        <iframe
                          src="https://www.loom.com/embed/c6111d17e44c4fb5897fb9e7b248aa8b?sid=d2324ca8-7936-4a92-ab11-dbf5a6b07174"
                          frameborder="0"
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowfullscreen
                          title="Askable"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                          onLoad={() => handleIframeLoad("askable")}
                        ></iframe>
                      </div>

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <div
                        style={{
                          position: "relative",
                          paddingTop: "56.25%" /* 16:9 ratio */,
                        }}
                        id="currency-convert"
                      >
                        {loadingStates["currency-convert"] && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                            <div className="text-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-2"></div>
                              <p className="text-sm text-gray-600">
                                Loading video...
                              </p>
                            </div>
                          </div>
                        )}
                        <iframe
                          src="https://www.loom.com/embed/2d189a36c10c4f7fa569e15a5c988f8a?sid=bb34e6b0-cb4f-4421-80a1-e03619ad4c72"
                          frameborder="0"
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowfullscreen
                          title="currency convertor Video"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                          onLoad={() => handleIframeLoad("currency-convert")}
                        ></iframe>
                      </div>

                      <hr className="border-t-2 border-gray-300 my-10" />

                      <div
                        style={{
                          position: "relative",
                          paddingTop: "56.25%" /* 16:9 ratio */,
                        }}
                        id="video-esign"
                      >
                        {loadingStates["video-esign"] && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                            <div className="text-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-2"></div>
                              <p className="text-sm text-gray-600">
                                Loading video...
                              </p>
                            </div>
                          </div>
                        )}
                        <iframe
                          src="https://www.loom.com/embed/9c8cc90b852e4cedb051f79df1d14c00?sid=004a1a59-b507-45f7-9ca5-64c27a61e230"
                          frameborder="0"
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowfullscreen
                          title="eSignPDF Video"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                          onLoad={() => handleIframeLoad("video-esign")}
                        ></iframe>
                      </div>

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <div
                        style={{
                          position: "relative",
                          paddingTop: "56.25%" /* 16:9 ratio */,
                        }}
                        id="summarize"
                      >
                        {loadingStates["summarize"] && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                            <div className="text-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-2"></div>
                              <p className="text-sm text-gray-600">
                                Loading video...
                              </p>
                            </div>
                          </div>
                        )}
                        <iframe
                          src="https://www.loom.com/embed/9ec565452c5341b3b04e751ac40a1252?sid=9cc01458-b7c4-4889-acd6-b66071971352"
                          frameborder="0"
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowfullscreen
                          title="Summarize"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                          onLoad={() => handleIframeLoad("summarize")}
                        ></iframe>
                      </div>

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <div
                        style={{
                          position: "relative",
                          paddingTop: "56.25%" /* 16:9 ratio */,
                        }}
                        id="video-ats"
                      >
                        {loadingStates["video-ats"] && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                            <div className="text-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-2"></div>
                              <p className="text-sm text-gray-600">
                                Loading video...
                              </p>
                            </div>
                          </div>
                        )}
                        <iframe
                          src="https://www.loom.com/embed/6054ad1c05244df68383aebed5a25fbd?sid=22eec304-69a6-4c60-9a04-0021a18460ef"
                          frameborder="0"
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowfullscreen
                          title="ResumeFix"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                          onLoad={() => handleIframeLoad("summarize")}
                        ></iframe>
                      </div>
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-social"
                        src={sumly_socialmedia}
                        alt="Social Media Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-shopping"
                        src={sumly_shopping}
                        alt="Social Media Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-web-pages"
                        src={sumly_webpage}
                        alt="Web Pages Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="linkedin"
                        src={sumly_linkedin}
                        alt="LinkedIn"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-target-web-pages"
                        src={sumly_targetwebpage}
                        alt="Web Pages Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-documents"
                        src={sumly_document}
                        alt="Documents Example"
                        className="w-full h-50 object-contain"
                      />

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-ai-chats"
                        src={sumly_aichat}
                        alt="AI Chats Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-github"
                        src={sumly_github}
                        alt="GitHub Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-emails"
                        src={sumly_emails}
                        alt="Emails Example"
                        className="w-full h-50 object-contain"
                      />

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-forms"
                        src={sumly_forms}
                        alt="Forms Example"
                        className="w-full h-50 object-contain"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* all about sumly  */}

              <div
                id="all-about-sumly"
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
              >
                <div>
                  <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                    ALL ABOUT SUMLY
                  </h2>

                  <div
                    style={{
                      position: "relative",
                      paddingBottom: "56.25%",
                      height: 0,
                    }}
                  >
                    <iframe
                      src="https://www.loom.com/embed/fc51e174b8c24d59917858dc6b3f81b7?sid=83f99487-86a3-4b1c-b2ee-623d1dc18727"
                      frameborder="0"
                      webkitallowfullscreen
                      mozallowfullscreen
                      allowfullscreen
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                      title="All about sumly"
                    ></iframe>
                  </div>
                </div>
              </div>

              {/* Links Section */}
              <div
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
                id="access_points"
              >
                <div>
                  <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                    ACCESS POINTS
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
                    <a
                      href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="border-2 border-black p-4 text-center">
                        <div className="font-bold mb-2">CHROME STORE</div>
                        <div className="text-sm">Install Sumly Extension</div>
                      </div>
                    </a>
                    <a
                      href="https://github.com/Prabhav25/Sumly"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="border-2 border-black p-4 text-center">
                        <div className="font-bold mb-2">GITHUB</div>
                        <div className="text-sm">GitHub Repo</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl">
                <div className="border-2 border-black p-6 text-center bg-gray-100">
                  <div className="font-bold text-lg mb-2">
                    POWERED BY: GOOGLE GEMINI AI
                  </div>
                  <div className="text-sm">
                    Intelligent • Contextual • Multi-Language • Universal
                  </div>
                  <div className="mt-4 font-bold">
                    Smart Summaries • &nbsp; AI Resume Fixes • &nbsp; Offline
                    PDF Signing • &nbsp; Web Sticky Notes • &nbsp; Ask with AI •
                    &nbsp; Live Currency Converter
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Sumly;
